module.exports = __webpack_public_path__ + "media/images/icons/roadmap-da463661116125278dd4f524fbfd0168.svg";